var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0H28V28H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.917,13.167A2.917,2.917,0,1,0,16,10.25,2.908,2.908,0,0,0,18.917,13.167ZM10.167,12a3.5,3.5,0,1,0-3.5-3.5A3.485,3.485,0,0,0,10.167,12Zm8.75,3.5c-2.135,0-6.417,1.073-6.417,3.208v2.625H25.333V18.708C25.333,16.573,21.052,15.5,18.917,15.5Zm-8.75-1.167C7.448,14.333,2,15.7,2,18.417v2.917h8.167V18.708c0-.992.385-2.73,2.765-4.048A14.33,14.33,0,0,0,10.167,14.333Z",
    transform: "translate(0.333 0.833)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.41b7c0cfec92ebd3948ecb451ab197ac.svg";
export { ForwardRef as ReactComponent };